<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER QISMI -->
      <div class="header-row">
        <h2 class="page-title">{{ $t($route.name) }}</h2>
        <div class="header-actions">

          <!-- Qidiruv -->
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input v-model="filter" type="search" :placeholder="$t('Қидирув')" class="modern-search">
          </div>

          <!-- Refresh tugmasi -->
          <button class="refresh-btn" @click="Data()" :title="$t('Yangilash')">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>

          <!-- Qo'shish tugmasi (Gradient) -->
          <button class="add-btn" @click="Href('/kassaorder/create')" v-if="rule.open == true">
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Қўшиш") }} <sup>ins</sup>
          </button>

          <top></top>
        </div>
      </div>

      <!-- JADVAL QISMI -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 70px">{{ $t('Факт №') }}</th>
                <th style="width: 170px">{{ $t('Вақт') }}</th>
                <th>{{ $t('Склад') }}</th>
                <th style="text-align: right;">{{ $t('Сумма') }}</th>
                <th style="text-align: right;">{{ $t('Сумма') }} $</th>
                <th>{{ $t('Фойдаланувчи') }}</th>
                <th style="width: 110px; text-align: center;">{{ $t('AMALLAR') }}</th>
              </tr>
            </thead>
            <tbody>
              <!-- Ma'lumotlar -->
              <tr v-for="item in filteredRows" :key="item.id" @dblclick="Update(item)">
                <td><span class="id-badge">{{ item.number }}</span></td>
                <td><span class="text-muted small">{{ $formatDate(item.datetime) }}</span></td>
                <td class="font-bold">{{ item.sklad ? item.sklad.name : '—' }}</td>
                <td class="text-right" :class="Number(item.summa) < 0 ? 'amount-out' : 'amount-in'">
                  {{ item.summa | numFormat }}
                </td>
                <td class="text-right" :class="Number(item.dollar_summa) < 0 ? 'amount-out' : 'amount-in'">
                  {{ item.dollar_summa | numFormat }}
                </td>
                <td>{{ item.user ? item.user.first_name : '—' }}</td>
                <td>
                  <div class="actions" v-if="rule.change == true">
                    <button class="icon-btn edit" @click="$router.push('/kassaorder/update/' + item.id)">
                      <b-icon icon="pencil-square"></b-icon>
                    </button>
                    <button class="icon-btn del" @click="Trash(item.id)">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Bo'sh holat -->
              <tr v-if="filteredRows.length === 0">
                <td colspan="7" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- FOOTER (Hisob ma'lumoti) -->
        <div class="table-footer">
          <div class="info">
            {{ $t('Jami') }}: <b>{{ filteredRows.length }}</b> {{ $t('ta') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Top from "../Layout/Top.vue";
import { print } from "../../components/mixins/print.js";

export default {
  mixins: [print],
  components: { Top },
  data() {
    return {
      items: [],
      filter: "",
      errors: "",
    };
  },
  computed: {
    filteredRows() {
      const q = (this.filter || "").toString().toLowerCase().trim();
      if (q.length < 1) return this.items;
      return this.items.filter(item => {
        const number = (item.number != null ? item.number.toString() : "");
        const sklad = item.sklad ? item.sklad.name.toLowerCase() : "";
        const user = item.user ? (item.user.first_name || "").toLowerCase() : "";
        const summa = (item.summa != null ? item.summa.toString() : "");
        return number.includes(q) || sklad.includes(q) || user.includes(q) || summa.includes(q);
      });
    }
  },
  mounted() {
    this.Data();
  },
  methods: {
    Update(record) {
      if (this.rule.open == true) {
        this.$router.push({ path: '/kassaorder/update/' + record.id });
      }
    },
    Data() {
      let self = this;
      axios({
        method: "get",
        url: "api/v1/kassa-order",
        headers: { "Content-Type": "application/json" }
      })
        .then(function (response) {
          self.items = response.data;
        })
        .catch(function (error) {
          self.errors = error.message;
        });
    },
    Trash(id) {
      let self = this;
      self.$prompt(self.$t("Паролни киритинг")).then(text => {
        if (text == self.update_password) {
          axios({
            method: "delete",
            url: "api/v1/kassa-order/id/" + id
          }).then(function () {
            self.Data();
          });
        } else {
          self.$store.state.errors = self.$t("Парол хато");
        }
      })
        .catch(function () { });
    }
  }
};
</script>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* SEARCH INPUT */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  transition: 0.3s;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

/* TUGMALAR */
.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}

.add-btn sup {
  opacity: 0.7;
  font-size: 10px;
}

.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
}

/* JADVAL KARTASI */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
  color: #334155;
}

.custom-table tbody tr {
  cursor: pointer;
  transition: background 0.15s;
}

.custom-table tbody tr:hover {
  background: #faf5ff;
}

.text-right {
  text-align: right;
}

.amount-in {
  color: #16a34a;
  font-weight: 700;
}

.amount-out {
  color: #e11d48;
  font-weight: 700;
}

/* ID badge */
.id-badge {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.font-bold {
  font-weight: 700;
}

/* AMALLAR */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 13px;
}

.empty-row {
  text-align: center;
  padding: 60px;
  color: #94a3b8;
  font-style: italic;
}
</style>
